exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input.ng-invalid.ng-touched{\n\tborder:1px solid red;\n}\n\nselect.ng-invalid.ng-touched{\n\tborder:1px solid red;\n}\n\nlabel.font-size-17{\n\tfont-size: 17px;\n}\n\n.zero-bottom-margin{\n\tmargin-bottom: 0px;\n}\n.rrform_error_message\n{\n\tcolor: red;\n}\n\ntr {\n    cursor: pointer;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/meghneel/work/shree_translogic_dashboard/src/app/r-r-form/r-r-form.component.css
// module id = ../../../../../src/app/r-r-form/r-r-form.component.css
// module chunks = main